import { useContext } from 'react';
import { getMimicContext } from '../utils/getMimicContext';
import { MimicContext } from '../interfaces/MimicContext';

export const useMimic = () => {
  const context = getMimicContext();
  return useContext<MimicContext>(context);
};
